import { Button, Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ButtonsDesktop.css';

interface IButtonsDesktopProps {
  onChangeFilters(): void;
  onResetFilters(): void;
  isFiltersLoading: boolean;
  isButtonsDisabled: boolean;
}

export const ButtonsDesktop: React.FC<IButtonsDesktopProps> = ({
  onChangeFilters,
  onResetFilters,
  isFiltersLoading,
  isButtonsDisabled,
}) => {
  return (
    <Responsive desktop>
      <div className={styles['container']}>
        <Button
          theme="fill_primary"
          onClick={onChangeFilters}
          size="L"
          disabled={isButtonsDisabled}
          loading={isFiltersLoading}
        >
          Применить
        </Button>
        <Button theme="fill_white_primary" onClick={onResetFilters} size="L" disabled={isButtonsDisabled}>
          Сбросить все
        </Button>
      </div>
    </Responsive>
  );
};
